module.exports = __webpack_public_path__ + "media/images/icons/outlined/inbox-d0b98fe7e135d9a72b27b70318050564.svg";